/**
 * Centralised soft-launch feature gating. Wraps a route's children with
 * a "Coming soon" placeholder when the feature is hidden, so a bookmark
 * or back-button doesn't dump users on a half-finished page during the
 * launch window.
 */

// Soft-launch flag — set to false to re-enable the page after launch.
export const BILLING_HIDDEN_SOFT_LAUNCH = true;
